import store from '../store.js'
import { getAuth } from 'firebase/auth';

export function fetchWeather(building) {
  store.dispatch({ type: 'FETCH_WEATHER_BEGIN' });

  getAuth().currentUser.getIdToken(true).then(token => {
    fetch(`/api/fetchWeather?site=${encodeURIComponent(building)}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(response => {
      if (response.ok) {
        return response.json().then(data => {
          store.dispatch({ type: 'FETCH_WEATHER_COMPLETE', payload: data });
        });
      }
      store.dispatch({ type: 'FETCH_WEATHER_ERROR' });
    }).catch(() => {
      store.dispatch({ type: 'FETCH_WEATHER_ERROR' });
    });
  }).catch(() => {
    store.dispatch({ type: 'FETCH_WEATHER_ERROR' });
  });
}
